import { combineReducers } from "redux";

import authenticationSlice from "redux/slices/authenticationSlice";
import notificationSlice from "redux/slices/notificationSlice";
import allUsersSlice from "redux/slices/allUsersSlice";
import dashboardSlice from "redux/slices/dashboardSlice";
import voucherSlice from "redux/slices/voucherSlice";

const rootReducer = combineReducers({
  authentication: authenticationSlice,
  notifications: notificationSlice,
  allUsers: allUsersSlice,
  dashboard: dashboardSlice,
  voucher: voucherSlice
});

export default rootReducer;
